import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import DataList from 'components/ui/DataListAlt';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import moment from 'moment';
import { diff } from 'deep-diff';
import CargomaticCard from 'components/v2/card';
import AccessorialsMapping from './AccessorialsMapping';
import ShipmentsActionCreators from '../../../actions/ShipmentsActionCreators';
import AddOrAdjustDrayageAccessorialModal from '../shipments/accounting/AddOrAdjustDrayageAccessorialModal';
import EquipmentViewModal from '../../ui/tailwind/modals/EquipmentViewModal';
import { isIntermodalShipmentType } from '../../../helpers/shipment-types';
class AccessorialsList extends Component {
    constructor(props) {
        super(props);
        this.getShipmentsWithAccessorials = (order) => {
            const { equipments } = order;
            const { shipments } = this.props;
            const accessorials = [];
            shipments
                .filter((s) => (s.payables || []).some((payable) => payable.category === 'accessorials') ||
                (s.receivables || []).some((receivable) => receivable.category === 'accessorials'))
                .map((s) => {
                const payableAccessorials = (s.payables || [])
                    .filter((payable) => payable.category === 'accessorials')
                    .map((a) => {
                    const accessorial = Object.assign(Object.assign({}, a), { job_id: s._id, shipment_id: s.shipment_id, equipment: this.getEquipmentId(equipments, a.equipment), ledger: 'payables', accessorial_type: a.message, carrier_cost: a.value, shipper_rate: 0 });
                    return Object.assign(Object.assign({}, accessorial), { editClick: !accessorial.accessorial_request_id
                            ? this.editAccessorial.bind(this, accessorial)
                            : null, reverseClick: !accessorial.accessorial_request_id
                            ? this.reverseAccessorial.bind(this, accessorial)
                            : null, viewClick: () => this.setState({
                            currentEquipment: accessorial.equipment,
                            showEquipmentModal: true,
                        }) });
                });
                const receivableAccessorials = (s.receivables || [])
                    .filter((receivable) => receivable.category === 'accessorials')
                    .map((a) => {
                    const accessorial = Object.assign(Object.assign({}, a), { job_id: s._id, shipment_id: s.shipment_id, equipment: this.getEquipmentId(equipments, a.equipment), ledger: 'receivables', accessorial_type: a.message, carrier_cost: 0, shipper_rate: a.value });
                    return Object.assign(Object.assign({}, accessorial), { editClick: !accessorial.accessorial_request_id
                            ? this.editAccessorial.bind(this, accessorial)
                            : null, reverseClick: !accessorial.accessorial_request_id
                            ? this.reverseAccessorial.bind(this, accessorial)
                            : null, viewClick: () => this.setState({
                            currentEquipment: accessorial.equipment,
                            showEquipmentModal: true,
                        }) });
                });
                const shipmentAccessorials = payableAccessorials.concat(receivableAccessorials);
                accessorials.push(...shipmentAccessorials);
            })
                .pop();
            return _.sortBy(_.sortBy(accessorials, 'accessorial_type'), 'shipment_id');
        };
        this.handleAddBulkAccessorialsClick = () => this.props.onAddBulkAccessorials();
        this.handleCloseModal = () => {
            const { t } = this.props;
            this.setState({
                showAlert: false,
                confirmMessage: null,
                showAccessorialModal: false,
                currentShipment: null,
                showEquipmentModal: false,
                currentEquipment: null,
                reverseAccessorial: false,
                confirmModalTitle: t('CONFIRM'),
            });
        };
        this.handleConfirm = () => {
            const { ledger, shipment_id, processed } = this.state.currentAccessorial;
            const shipment = this.findShipment(shipment_id);
            if (this.state.reverseAccessorial ||
                processed.toUpperCase().trim() === 'YES') {
                this.createCustomAdjustment(this.state.currentAccessorial, true).then((customAdjustment) => ShipmentsActionCreators.addAdjustment(shipment, ledger, customAdjustment));
            }
            else {
                this.handleRemoveAdjustmentConfirm(shipment);
            }
            this.handleCloseModal();
        };
        this.handleReverseAdjustment = () => {
            const { ledger, shipment_id } = this.state.currentAccessorial;
            const shipment = this.findShipment(shipment_id);
            this.createCustomAdjustment(this.state.currentAccessorial).then((customAdjustment) => ShipmentsActionCreators.addAdjustment(shipment, ledger, customAdjustment));
        };
        this.handleEditAdjustment = (editedAdjustments, shipment = null) => {
            const { adjustment } = editedAdjustments;
            const { ledger, _id } = adjustment;
            const adjustments = _.clone(shipment[ledger]);
            const adjustmentIndex = adjustments.findIndex((a) => a._id === _id);
            if (adjustmentIndex === -1)
                return;
            if (shipment &&
                isIntermodalShipmentType(shipment) &&
                adjustments[adjustmentIndex].processed) {
                this.handleEditExistingAdjustment(adjustment);
            }
            else {
                Object.keys(_.omit(adjustment, ['ledger', '_id'])).forEach((key) => {
                    adjustments[adjustmentIndex][key] =
                        key === 'value'
                            ? parseInt(adjustments[adjustmentIndex][key], 10) +
                                parseInt(adjustment[key], 10)
                            : adjustment[key];
                });
                ShipmentsActionCreators.updateAdjustments(shipment, {
                    [ledger]: adjustments,
                });
            }
        };
        this.handleEditExistingAdjustment = (adjustments) => {
            this.setState({ showAccessorialModal: false });
            adjustments.forEach((data) => {
                const { ledger, adjustment } = data;
                ShipmentsActionCreators.addAdjustment(this.state.currentShipment, ledger, adjustment);
            });
        };
        this.handleRemoveAdjustment = () => {
            this.setState({ showAccessorialModal: false }, () => this.handleRemoveAdjustmentAlert());
        };
        this.handleRemoveAdjustmentAlert = () => {
            const { t } = this.props;
            this.setState({
                confirmModalTitle: t('REMOVE_ACCESSORIAL'),
                confirmMessage: t('REMOVE_ACCESSORIAL_CONFIRMATION'),
                showAlert: true,
            });
        };
        this.handleRemoveAdjustmentConfirm = (shipment) => {
            const { _id, ledger } = this.state.currentAccessorial;
            const adjustments = _.clone(shipment[ledger]);
            const adjustmentIndex = adjustments.findIndex((a) => a._id === _id);
            if (adjustmentIndex === -1)
                return;
            adjustments.splice(adjustmentIndex, 1);
            ShipmentsActionCreators.updateAdjustments(shipment, {
                [ledger]: adjustments,
            });
        };
        this.state = this.getInitialState(props.order);
    }
    getInitialState(order) {
        const { t } = this.props;
        return {
            accessorials: this.getShipmentsWithAccessorials(order),
            shipments: this.props.shipments,
            equipmentList: _.uniq(order.equipments) || [],
            showEquipmentModal: false,
            showAlert: false,
            confirmModalTitle: t('CONFIRM'),
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const propDiff = diff(this.props.order, nextProps.order);
        const shouldUpdate = !!(propDiff &&
            propDiff.filter((d) => !d.path.includes('created_at') || !d.path.includes('modified_at')));
        if (shouldUpdate) {
            this.setState(this.getInitialState(nextProps.order));
        }
    }
    getEquipmentId(equipmentList, id) {
        const equipment = equipmentList && equipmentList.filter((e) => e._id === id).pop();
        return equipment || '';
    }
    getEquipmentList(shipment) {
        return _.uniq(shipment.stops.reduce((equipmentList, stop) => equipmentList.concat(stop.equipments), []), (equipment) => equipment._id);
    }
    findShipment(id) {
        const shipment = this.state.shipments.filter((s) => s.shipment_id === id);
        return shipment ? shipment.pop() : null;
    }
    editAccessorial(accessorial) {
        const shipment = this.findShipment(accessorial.shipment_id);
        if (shipment) {
            this.setState({
                currentAccessorial: accessorial,
                currentShipment: shipment,
                equipmentList: this.getEquipmentList(shipment),
            }, () => {
                this.createCustomAdjustment(accessorial).then((customAdjustment) => this.setState({ customAdjustment, showAccessorialModal: true }));
            });
        }
    }
    createCustomAdjustment(accessorial, negateValue = false) {
        const { charge_id, charge_code, processed, value, equipment, message, type, ledger, begin_datetime, end_datetime, appointment, location, custom_description, _id, } = accessorial;
        return Promise.resolve({
            charge_id,
            charge_code,
            adjustedItem: 'accessorial',
            category: 'accessorials',
            equipment: equipment._id,
            message: message.toLowerCase().includes('adjustment')
                ? message
                : `${message} Adjustment`,
            type,
            value: negateValue ? value * -1 : value,
            ledger,
            begin_date: begin_datetime ? moment(begin_datetime) : null,
            begin_time: begin_datetime && appointment ? moment(begin_datetime) : null,
            end_date: end_datetime ? moment(end_datetime) : null,
            end_time: end_datetime && appointment ? moment(end_datetime) : null,
            location,
            custom_description,
            processed,
            _id,
        });
    }
    reverseAccessorial(accessorial) {
        const { t } = this.props;
        this.setState({
            confirmModalTitle: t('REVERSE_ACCESSORIAL'),
            currentAccessorial: accessorial,
            confirmMessage: t('REVERSE_ACCESSORIAL_CONFIRMATION_WITH_VALUE', {
                shipment_id: accessorial.shipment_id,
            }),
            showAlert: true,
            reverseAccessorial: true,
        });
    }
    renderBulkAddAccessorialsButton() {
        const { t } = this.props;
        const shipments = (this.props.order || {}).shipments || [];
        if (shipments.length === 0) {
            return null;
        }
        return (React.createElement("button", { className: "mb-4 button button-hollow-green sm:mb-0", onClick: this.handleAddBulkAccessorialsClick }, t('ADD_BULK_ACCESSORIALS')));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(CargomaticCard, { header: () => (React.createElement("div", { className: "items-center justify-between sm:flex" },
                React.createElement("h3", { className: "mt-0 mb-4 sm:mb-0" }, t('ACCESSORIAL_MANAGEMENT_CENTER')),
                this.renderBulkAddAccessorialsButton())) },
            React.createElement(DataList, { data: this.state.accessorials, columns: AccessorialsMapping.columns.map((item) => (Object.assign(Object.assign({}, item), { text: titleize(t(item.localizationSlug, {
                        count: (item === null || item === void 0 ? void 0 : item.count) || 1,
                    })) }))), showHeaders: true, noDataIndication: t('NO_ACCESSORIALS_FOUND') }),
            React.createElement(ConfirmModal, { show: this.state.showAlert, title: this.state.confirmModalTitle, message: this.state.confirmMessage, onConfirm: this.handleConfirm, onHide: this.handleCloseModal }),
            this.state.showAccessorialModal && (React.createElement(AddOrAdjustDrayageAccessorialModal, { shipment: this.state.currentShipment, show: this.state.showAccessorialModal, customAdjustment: this.state.customAdjustment, equipment: this.state.equipmentList, onSave: this.handleEditExistingAdjustment, onHide: this.handleCloseModal, onEditAdjustment: this.handleEditAdjustment, onRemoveAdjustment: this.handleRemoveAdjustment })),
            React.createElement(EquipmentViewModal, { show: this.state.showEquipmentModal, equipment: this.state.currentEquipment, onHide: this.handleCloseModal })));
    }
}
AccessorialsList.propTypes = {
    order: PropTypes.object.isRequired,
    onAddBulkAccessorials: PropTypes.func.isRequired,
};
export default withTranslation()(AccessorialsList);
